import { render } from "./CguItem.vue?vue&type=template&id=357c6758&scoped=true"
import script from "./CguItem.vue?vue&type=script&lang=js"
export * from "./CguItem.vue?vue&type=script&lang=js"

import "./CguItem.vue?vue&type=style&index=0&id=357c6758&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-357c6758"]])

export default __exports__